"use strict"

import Axios from "../../../services/AxiosService"

class Service extends Axios {
  async index() {
    return this.request({
      method: "GET",
      url: `routes`,
    })
  }

  async show(id: string) {
    return this.request({
      method: "GET",
      url: `routes/${id}`,
    })
  }

  async status({ id, ...data }: any) {
    return this.request({
      method: "PUT",
      url: `/routes/${id}/status-routes`,
      data,
    })
  }

  async activateRoutes(selected: Object[]) {
    return this.request({
      method: "patch",
      url: "/routes/activate-routes",
      data: { ids: selected },
    })
  }

  async disableRoutes(selected: Object[]) {
    return this.request({
      method: "patch",
      url: "/routes/disable-routes",
      data: { ids: selected },
    })
  }
}

export default () => new Service()
